import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import { VpHookFormSelect, VpHookFormColorInput } from '../..';
import { useFetchPluginById, useFetchPluginOptions } from '../../../hooks';
import { VpPluginFontFamilySelect } from './VpPluginFontFamilySelect';

import config from '../../../config';

export const VpPluginTextTitleInputs = ({ disabled }) => {
  const { data } = useFetchPluginById();
  const { data: optionsData } = useFetchPluginOptions({ enabled: config?.pluginFontSizeEnabled });

  return (
    <Stack direction="row" alignItems="end" spacing={1}>
      <VpPluginFontFamilySelect
        smallLabel
        defaultValue={data?.styles?.titleFont}
        name="titleFont"
        disableHelperText
        disabled={disabled}
        selectDefault
      />
      {config?.pluginFontSizeEnabled && (
        <VpHookFormSelect
          options={optionsData?.titleFontSizes}
          required
          defaultValue={data?.styles?.titleFontSize}
          name="titleFontSize"
          disableHelperText
          disabled={disabled}
          selectDefault
        />
      )}
      <VpHookFormColorInput
        required
        name="titleFontColor"
        disableHelperText
        defaultValue={data?.styles.titleFontColor}
        disabled={disabled}
      />
    </Stack>
  );
};

VpPluginTextTitleInputs.propTypes = {
  disabled: PropTypes.bool
};

export default VpPluginTextTitleInputs;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginTextTitleInputs.jsx